import styled from 'styled-components';

const ORDER_SUMMARY_GAP = '20rem';

export const OrderSummaryContainer = styled.div(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '50% 50%',
  gridTemplateRows: 'auto auto',
  gridTemplateAreas: `
      "carousel orderDetails"
      "whatToExpect orderDetails"
      "youMayAlsoLike orderDetails"
    `,
  gap: ORDER_SUMMARY_GAP,

  [theme.breakpoint.media.max.sm]: {
    gridTemplateColumns: '100%',
    gridTemplateRows: 'auto auto auto',
    gridTemplateAreas: `
    "carousel"
    "orderDetails"
    "whatToExpect"
    "youMayAlsoLike"
  `,
  },

  [theme.breakpoint.media.minMf.md]: {
    gridTemplateColumns: '66% 34%',
  },
}));

export const CarouselArea = styled.div({
  gridArea: 'carousel',
  width: '100%',
  marginLeft: 0,
});

export const OrderDetailsCard = styled.div(({ theme }) => ({
  backgroundColor: theme.palette.white,
  boxSizing: 'border-box',
  boxShadow: `2rem 2rem 30rem ${theme.palette.darkLiver}66`,
  borderRadius: '5rem',
  padding: '16rem 0',
  width: '100%',
  height: '100%',
  marginTop: '5rem',

  gridArea: 'orderDetails',

  [theme.breakpoint.media.minMf.sm]: {
    width: `calc(100% - ${ORDER_SUMMARY_GAP} + 35rem)`,
    padding: '16rem',
    marginTop: '-30rem',
  },

  [theme.breakpoint.media.minMf.md]: {
    width: `calc(100% - ${ORDER_SUMMARY_GAP} + 60rem)`,
    padding: '16rem 36rem',
    height: 'auto',
  },
}));

export const WhatToExpectArea = styled.div(() => ({
  gridArea: 'whatToExpect',
  width: '100%',
}));

export const YouMayAlsoLikeArea = styled.div(({ theme }) => ({
  gridArea: 'youMayAlsoLike',
  width: '100%',
  marginBlockStart: '30rem',

  [theme.breakpoint.media.minMf.sm]: {
    marginLeft: '-24rem',
  },

  [theme.breakpoint.media.minMf.md]: {
    marginLeft: 0,
  },
}));
